import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeanInputComponent } from './components/lean-input/lean-input.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { LeanCard } from './components/lean-card/lean-card.component';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { PerfectScrollbarModule, PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { AgmCoreModule, GoogleMapsAPIWrapper } from '@agm/core';
import { AgmDirectionModule} from "agm-direction"
import { ToastrModule } from 'ngx-toastr';
import { LeanSelectComponent } from './components/lean-select/lean-select.component';
import { LeanDatatableComponent } from './components/legacy/lean-datatable/lean-datatable.component';
import { LeanDataFormComponent } from './components/lean-data-form/lean-data-form.component';
import { LeanListComponent } from './components/legacy/lean-list/lean-list.component';
import { LeanTableComponent } from './components/lean-table/lean-table.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { LeanSelect2Component } from './components/lean_select2/lean_select2.component';
import { LeanWidget } from './components/lean-widget/lean-widget.component';
import { LeanMapComponent } from './components/legacy/lean-map/lean-map.component';
import { LeanDataModal } from './components/lean-data-modal/lean-data-modal.component';
import { LeanPostitKpiComponent } from './components/lean-postit-kpi/lean-postit-kpi.component';
import { LeanPostitComponent } from './components/lean-postit/lean-postit.component';
import { DateRangePipe } from './pipes/date-range-pipe';
import { LeanKpiComponent } from './components/lean-kpi/lean-kpi.component';
import { LeanModal } from './components/lean-modal/lean-modal.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { LeanTreeComponent } from './components/lean-tree/lean-tree.component';
import { LeanMenuComponent } from './components/lean-menu/lean-menu.component';
import { TemplateComponent } from './components/_entities/templatte';
import { LeanStepComponent } from './components/lean-step/lean-step.component';
import { LeanStepHelpComponent } from './components/lean-step-help/lean-step-help.component';
import { NgxGaugeModule } from 'ngx-gauge';
import { LeanConfirmationComponent } from './components/lean-confirmation/lean-confirmation.component';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { DecimaDigitNumberDirective } from './directives/decimal-digits-number';
import { LeanStepVerticalComponent } from './components/lean-step-vertical/lean-step-vertical.component';
import { LeanCompositKpiComponent } from './components/lean-composit-kpi/lean-composit-kpi.component';
import { LeanCompositComponent } from './components/lean-composit/lean-composit.component';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};


export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  
  declarations: [
    LeanCard,
    LeanInputComponent,
    LeanModal,
    LeanTreeComponent,
    LeanMenuComponent,
    LeanListComponent,
    LeanSelectComponent,
    LeanSelect2Component,
    LeanDatatableComponent,
    LeanDataFormComponent,
    LeanTableComponent,
    LeanWidget,
    LeanMapComponent,
    LeanDataModal,
    LeanPostitKpiComponent,
    LeanCompositKpiComponent,
    LeanCompositComponent,
    LeanPostitComponent,
    DateRangePipe,
    LeanKpiComponent,
    TemplateComponent,
    LeanStepComponent,
    LeanStepVerticalComponent,
    LeanStepHelpComponent,
    LeanConfirmationComponent,
    DecimaDigitNumberDirective
  ],

  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    NgxDatatableModule,
    NgxGaugeModule,
    AgmDirectionModule,
    PerfectScrollbarModule,
    HttpClientModule,
    BsDatepickerModule.forRoot(),
    CollapseModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
      }
    }),

    ToastrModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDzuhEiYdkplbXBElZDvQr5BoG8Z5NrgwA'
    }),

  ],

  exports :[
    LeanMenuComponent,
    LeanInputComponent,
    LeanCard,
    NgSelectModule,
    TranslateModule,
    FormsModule,
    LeanTableComponent,
    LeanTreeComponent,

    LeanListComponent,
    LeanSelectComponent,
    LeanSelect2Component,
    LeanDatatableComponent,
    LeanDataFormComponent,
    LeanWidget,
    LeanMapComponent,
    LeanDataModal,
    LeanModal,
    LeanPostitKpiComponent,
    LeanCompositKpiComponent,
    LeanPostitComponent,
    LeanCompositKpiComponent,
    DateRangePipe,
    LeanKpiComponent,
    LeanStepComponent,
    LeanStepVerticalComponent,
    LeanStepHelpComponent,
    LeanConfirmationComponent,
    AgmCoreModule,
    AgmDirectionModule,
    DecimaDigitNumberDirective
  ],
  entryComponents:[
    LeanConfirmationComponent
  ],
  providers: [
    DateRangePipe,
    GoogleMapsAPIWrapper,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }]
})

export class ToolsModule { 


  static forRoot(): ModuleWithProviders {
    return {
      ngModule: ToolsModule,
      providers: []
    }
  }
  
  constructor( 
    protected translate : TranslateService
  ){
    translate.setDefaultLang('fr');
    translate.use('fr');
  }
}
